import { Heading } from '@/components/Cms/Heading/Heading';
import type { ContentfulHeadingFragment } from '@/graphql/contentful/api';

import type { CardProps } from '../../types';
import { CardRichTextRenderer } from '../BaseCardType/RichTextEditor/CardRichTextRenderer';

import * as S from './TextWithColumnsType.styles';

export const TextWithColumnsType = ({
  backgroundColor,
  cardText,
  cardText2,
  className,
  placeholderHeading,
  showMore,
  textAlignment,
  visibleInDesktop,
  visibleInMobile,
}: CardProps) => {
  return (
    <S.Wrapper
      $visibleInDesktop={visibleInDesktop}
      $visibleInMobile={visibleInMobile}
      backgroundColor={backgroundColor?.value ?? 'transparent'}
      className={className}
      data-testid='TextWithColumnsTypeWrapper'
    >
      {placeholderHeading && (
        <Heading
          Heading={placeholderHeading as ContentfulHeadingFragment}
          data-testid='TextWithColumnsTypeHeading'
        />
      )}
      <S.ColumnsTextContent
        data-testid='TextWithColumnsTypeColumnsTextContent'
        textAlignment={textAlignment ?? 'left'}
      >
        {cardText && (
          <CardRichTextRenderer
            enableShowMore={showMore ?? false}
            text={cardText}
          />
        )}
        {cardText2 && (
          <CardRichTextRenderer
            enableShowMore={showMore ?? false}
            text={cardText2}
          />
        )}
      </S.ColumnsTextContent>
    </S.Wrapper>
  );
};
